<template>
    <div>
      <div class="row no-gutters">
        <div class="col-md-12">
          <KTCodePreview v-bind:title="'Program Studi'">
            <template v-slot:toolbar>
                <b-button variant="success" class="mb-2" @click="getList()">
                    <b-icon icon="arrow-repeat" aria-hidden="true"></b-icon>
                </b-button>
            </template>
            <template v-slot:body>
              <v-card>
                <v-card-title>
                    <v-spacer></v-spacer>
                  <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="prodi" :search="search" class="custom-header" :loading="isLoading" :loading-text="`Loading... Please wait`">
                  <template v-slot:item.no="{ item }">
                    {{ item.no }}.
                  </template>
                </v-data-table>
              </v-card>
            </template>
          </KTCodePreview>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import KTCodePreview from "@/view/content/CardContent.vue";
  import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
//   import ButtonComponent from "@/view/content/components/button/buttonComponent.vue"
  import axios from "axios";
  
  export default {
    data() {
      return {
        prodi: [],
        search: "",
        headers: [
          { text: "No", value: "no", align: "center", sortable: false },
          { text: "Kode Prodi", value: "kodeProdi" },
          { text: "Nama Prodi", value: "namaProdi" },
          { text: "Status", value: "status" },
          { text: "Jenjang Pendidikan", value: "jenjangPendidikan" }
        ],
        isLoading: false
      };
    },
    components: {
      KTCodePreview,
    //   ButtonComponent
    },
    async mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Master Program Studi" }
      ]);
  
      await this.getData()
    },
    methods: {
      async getList(){
        this.prodi = [];
        this.isLoading = true;
        const result = await axios.get('master_dikti/sync_prodi');
        if (result.data.meta.code == 200) {
            await this.getData();
        }else{
            this.$swal('Error Server');
        }
      },

      async getData() {
        try {
          if (this.prodi) {
            this.prodi = [];
          }
          this.isLoading = true;
          // const startTime = Date.now();
          const result = await axios.get(`master_dikti/prodi/get_data`);
          const data = [];
          result.data.data.map((prodi, index) => {
            let obj = {
              no: index+1,
              kodeProdi: prodi.kode_program_studi,
              namaProdi: prodi.nama_program_studi,
              status: prodi.status,
              jenjangPendidikan: prodi.nama_jenjang_pendidikan
            }
            data.push(obj);
          });
          // const elapsedTime = new Date() - startTime;
          // If the elapsed time is less than a certain threshold, wait to reach the threshold
          // if (elapsedTime < 5000) {
              // await new Promise(resolve => setTimeout(resolve, 5000 - elapsedTime));
              this.prodi = data;
          // }
          this.isLoading = false;
          // this.rooms = result.data.data;
        } catch (err) {
          this.$swal(`Failed`);
        }
      },
    }
  }
  </script>
  
  <style scoped>
    .disableds {
      background-color: #E9ECEF;
    }
  </style>